import { iconByName } from '../../../components/IconPicker';
import { ColumnData } from '../../../components/data/DataTable';
import DataView from '../../../components/data/DataView';
import { Service } from '../../../models/Types';
import { ServiceForm, serviceParse } from './ServiceForm';

const columns: ColumnData<Service>[] = [{
    name: 'Icon',
    width: 35,
    sx: () => ({ pr: 0 }),
    renderer: v => v ? iconByName(v, { color: 'primary', fontSize: 'small' }) : null
}, {
    label: 'Наименование',
    name: 'Name',
    filter: true,
    routerLink: true
}, {
    label: 'Стоимость',
    name: 'Price',
    type: 'numeric',
    filter: true
}, {
    label: 'Ед.измерения',
    name: 'Unit',
    filter: true
}];

export default function ServiceView() {
    return <DataView<Service>
        title="Услуга"
        titleMultiple="Услуги"
        typeId="Service"
        form={(id, apiRef) => <ServiceForm id={id} apiRef={apiRef} />}
        tableProps={{ columns: columns, dataParser: serviceParse }} />;
}